import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Enquiries from './pages/Enquiries';
import About from './pages/About';
import Upload from './pages/Upload';
import Admin from './pages/Admin';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <div className="App">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/enquiries" element={<Enquiries />} />
            <Route path="/about" element={<About />} />
            <Route path="/upload/:token" element={<Upload />} />
            <Route path="/portal" element={<Admin />} />
          </Routes>
        </div>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
